module.exports = __webpack_public_path__ + "img/ri_hotel-line.4f70b87e.svg";